export default "__VITE_ASSET__f3f15448__"